import createReducer from '../../utils/createReducer';

const initialState = {
  locale: 'en',
  messages: {}
};

export default createReducer(initialState, {});
